import axios from "axios";
import { baseITAdminApi } from "src/config";
import { SteelRole } from "src/apps/it-admin/types/SteelRoleResponse";
import { SteelUser } from "src/apps/it-admin/types/SteelUserResponse";
import { CreateSteelUserPayload } from "src/apps/it-admin/types/CreateSteelUserPayload";
import { UpdateSteelUserPayload } from "src/apps/it-admin/types/UpdateSteelUserPayload";
import { TaskerWorkRole } from "src/apps/it-admin/types/WorkRole";
import { GrantAccessPayload } from "src/apps/it-admin/types/RoleAccessPayload";
import { TaskerInfoResponse } from "src/apps/it-admin/types/TaskerInfoResponse";
import { SteelLocationResponse } from "src/apps/it-admin/types/SteelLocationResponse";

const itaApiInstance = axios.create({
    baseURL: baseITAdminApi,
});

async function getSteelRoles()
{
    const response = await itaApiInstance.get<SteelRole[]>(
            `ita/steel/roles`,
        );
    
    return response.data;
}

async function getSteelUserRoles(data: {params: {userID: number}})
{
    const response = await itaApiInstance.get<number[]>(
            `ita/steel/users/${data.params.userID}/roles`,
            {
                params: {
                    userID: data.params.userID,
                }
            },
        );

    return response.data;
}

async function getSteelUsers()
{
    const response = await itaApiInstance.get<SteelUser[]>(
            `ita/steel/users`,
        );
    
    return response.data;
}

async function getSteelLocations()
{
    const response = await itaApiInstance.get<SteelLocationResponse[]>(
            `ita/steel/locations`,
        );
    
    return response.data;
}

async function createSteelUser(data: {
    payload: CreateSteelUserPayload
})
{
    await itaApiInstance.post(
            `/ita/steel/users`,
            {
                userLogin: data.payload.userLogin,
                userName: data.payload.userName,
                defaultLocationID: data.payload.defaultLocationID,
                activeTF: data.payload.activeTF,
                userEmail: data.payload.userEmail,
                password: data.payload.password,
                roleIDs: data.payload.roleIDs,
            },
    );
}

async function updateSteelUser(data: {
    payload: UpdateSteelUserPayload,
    userID: number,
})
{
    await itaApiInstance.put(
            `/ita/steel/users/${data.userID}`,
            {
                userLogin: data.payload.userLogin,
                userName: data.payload.userName,
                defaultLocationID: data.payload.defaultLocationID,
                activeTF: data.payload.activeTF,
                userEmail: data.payload.userEmail,
                roleIDs: data.payload.roleIDs,
            },
    );
}

async function updateSteelUserStatus(data: {
    isActive: boolean,
    userID: number,
})
{
    await itaApiInstance.patch(
            `/ita/steel/users/${data.userID}/status`,
            {
                isActive: data.isActive,
            },
    );
}

async function getTaskerRoles()
{
        const response = await itaApiInstance.get<TaskerWorkRole[]>(
            `/tasker/roles`,
        );
    
    return response.data;
}

async function getTaskerPersonInfo(data: {params: {personCode: string}})
{
    const response = await itaApiInstance.get<TaskerInfoResponse>(
            `/tasker/person-info`,
            {
                params: {
                    PersonCode: data.params.personCode,
                }
            },
        );
    
    return response.data;
}

async function updateTaskerRole(data : {
    payload: GrantAccessPayload
})
{
    await itaApiInstance.post(
            `/tasker/user-roles`,
            {
                EmployeeCode: data.payload.EmployeeCode,
                RoleId: data.payload.RoleId,
                SourceSystem: data.payload.SourceSystem,
                ChangedBy: data.payload.ChangedBy,
                Note: data.payload.Note,
            },
        );
}

const itAdminApi = {
    getSteelRoles,
    getSteelUserRoles,
    getSteelUsers,
    createSteelUser,
    updateSteelUser,
    updateSteelUserStatus,
    getTaskerRoles,
    getTaskerPersonInfo,
    updateTaskerRole,
    getSteelLocations,
}

export {itAdminApi};